module.exports = __webpack_public_path__ + "assets/img/2018_3.2eafdb09.png";